var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 121,
    viewBox: "0 0 74 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.48 63.4199H70.92V61.4199H73.48V63.4199ZM58.92 63.4199H48.92V61.4199H58.92V63.4199ZM36.92 63.4199H26.92V61.4199H36.92V63.4199ZM14.92 63.4199H4.91998V61.4199H14.92V63.4199ZM2 54.3398H0V44.3398H2V54.3398ZM2 32.3398H0V22.3398H2V32.3398ZM2 10.3398H0V0.339844H2V10.3398Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6399 120.34H53.6399V110.34H55.6399V120.34ZM55.6399 98.3398H53.6399V88.3398H55.6399V98.3398ZM55.6399 76.3398H53.6399V66.3398H55.6399V76.3398ZM55.6399 54.3398H53.6399V44.3398H55.6399V54.3398ZM55.6399 32.3398H53.6399V22.3398H55.6399V32.3398ZM55.6399 10.3398H53.6399V0.339844H55.6399V10.3398Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber4);
export default __webpack_public_path__ + "static/media/NUMBER_4.be93b862451989bb136f185073292283.svg";
export { ForwardRef as ReactComponent };